import BookingForm from "./BookingForm";
import {ToastContainer} from "react-toastify";

const BookingPage = () => {
return (
   <>
     <BookingForm/>
     <ToastContainer/>
   </>
)
};

export default BookingPage;
